// =====================================================================================
// INVRT Radar - web console - Skeleton (canonical mirror, Story N3)
//
// Mirror of the INVRT Design System's State/Skeleton for this console's Tailwind idiom:
// a quiet pulsing block whose geometry traces the component that is loading, wrapped in a
// role="status" container so the wait is announced. The canonical rules hold: never for a
// sub-second wait (use the Spinner), and match the real geometry so arrival does not jump.
// =====================================================================================

import { cn } from "@/lib/utils";

export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden="true" className={cn("animate-pulse rounded-lg bg-surface-muted", className)} />;
}

/**
 * The `table` preset: one shimmering row per expected result row (match the real page size
 * so nothing jumps), one block per column. The container carries the accessible name.
 */
export function TableSkeleton({
  label,
  rows,
  columns,
}: {
  label: string;
  rows: number;
  columns: number;
}) {
  return (
    <div
      role="status"
      aria-label={label}
      className="flex flex-col gap-3 rounded-card border border-line bg-surface p-4"
    >
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={`skeleton-row-${rowIndex}`}
          className="grid items-center gap-3"
          style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
        >
          {Array.from({ length: columns }).map((_, columnIndex) => (
            <Skeleton key={`skeleton-cell-${rowIndex}-${columnIndex}`} className="h-6" />
          ))}
        </div>
      ))}
    </div>
  );
}
